module.exports = __webpack_public_path__ + "img/face_id.740ed1c6.svg";